import React, { useContext } from 'react';
import {
	VideoCategoriesContext,
	IVideoCategoriesContext,
} from 'modules/Entertainment/Videos/VideoCategories/videoCategoriesState/videoCategoriesContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IVideoCategoriesContext>(VideoCategoriesContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
